"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var form_constants_1 = require("../../form-constants");
var data_format_1 = require("./data-format");
exports.defaultValues = __assign({}, data_format_1.defaultValues, { type: form_constants_1.dataFormatType.ZIP_EXTENSION, zipElementId: '', extensionElementId: '' });
exports.ZipExtensionFormatRecord = immutable_1.Record(exports.defaultValues);
/** the immutable implementation of IZipExtensionFormat */
var ImmutableZipExtensionFormat = /** @class */ (function (_super) {
    __extends(ImmutableZipExtensionFormat, _super);
    function ImmutableZipExtensionFormat(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableZipExtensionFormat;
}(exports.ZipExtensionFormatRecord));
exports.ImmutableZipExtensionFormat = ImmutableZipExtensionFormat;
//# sourceMappingURL=zip-format.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-elements/data-format/zip-format.js
// module id = 1140
// module chunks = 0